export default "__VITE_ASSET__1a38acde__"